export const getPerfis = ({ perfis }) => perfis;
export const getPagination = ({ pagination }) => pagination;
